import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CampaignsService,
  DBCampaignStatus,
} from "@/services/campaigns.service";
import { adsHttpClient } from "@/utils/ads.http";

const campaignsService = new CampaignsService(adsHttpClient);

type UpdateCampaignVariables = {
  campaignId: string;
  active: boolean;
  status: DBCampaignStatus;
};

export function useUpdateCampaign() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      campaignId,
      active,
      status,
    }: UpdateCampaignVariables) => {
      return campaignsService.update(campaignId, { active, status });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
}
